var styleDataHash = "cf3692d4";
const injectCss = () => {
  var css = `[dir] ._1pm7U{padding:18px 24px}.xBtsZ{--wsr-color-B10:var(--rcp-color-primary)}.xBtsZ button:hover{--wsr-color-B10:var(--rcp-color-hover)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var button_input_modal_default = {
  "content": "_1pm7U",
  "tabs": "xBtsZ"
};
export {
  button_input_modal_default as default,
  injectCss
};
//# sourceMappingURL=button-input-modal-scss.js.map
